import { render, staticRenderFns } from "./ContentArea.vue?vue&type=template&id=4021a15a"
import script from "./ContentArea.vue?vue&type=script&lang=js"
export * from "./ContentArea.vue?vue&type=script&lang=js"
import style0 from "./ContentArea.vue?vue&type=style&index=0&id=4021a15a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports